import React from 'react'

import { createStackNavigator } from '@react-navigation/stack'

import { useContent } from '@sart/content'
import { theme, colors } from '@sart/styles'

import { stackNavigationProps } from '../nagivationProps'

import TopUp from './TopUp'

const Stack = createStackNavigator()

function TopUpStackNavigator() {

  const content = useContent()

  return(
    <Stack.Navigator
      initialRouteName='TopUp'
      screenOptions={{
        ...stackNavigationProps.screenOptions
      }}
    >
      <Stack.Screen
        name="TopUp"
        component={TopUp}
        options={{
          title: "Top Up",
          headerTitleStyle: theme.navigationHeader,
        }}
      />
    </Stack.Navigator>
  )
}

export default TopUpStackNavigator